import { StepsLayout } from "@rapid/components/layout/StepsLayout";
import { VideoTrimmer } from "@rapid/components/file/VideoTrimmer";
import { useMedia } from "@rapid/contexts/MediaContext";

export const BuildLayout = ({
    Sidebar,
    VisualArea,
    BottomContent
}: {
    Sidebar?: React.ReactNode;
    VisualArea: React.ReactNode;
    BottomContent?: React.ReactNode;
}) => {
    const { mediaItemToTrim } = useMedia();

    return (
        <>
            <StepsLayout Sidebar={Sidebar} VisualArea={VisualArea} BottomContent={BottomContent} />
            {/* Video Trimmer Modal */}
            {mediaItemToTrim?.validation?.needsTrimming === true && <VideoTrimmer />}
        </>
    );
};
